
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setActiveSubmenu(null);
  };

  const toggleSubmenu = (submenu: string) => {
    setActiveSubmenu(activeSubmenu === submenu ? null : submenu);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveSubmenu(null);
  };

  return (
    <>
      {/* Header cerrado */}
      <header className="site-header fixed w-full top-0 z-50">
        <div className="mx-auto" style={{ paddingLeft: 'clamp(1rem, 3vw, 5rem)', paddingRight: 'clamp(1rem, 3vw, 5rem)' }}>
          <div className="flex items-center justify-between" style={{ paddingTop: 'clamp(1rem, 2vh, 2rem)', paddingBottom: 'clamp(1rem, 2vh, 2rem)' }}>
            {/* Hamburger Menu Button - Left */}
            <button 
              className="menu-toggle hamburger p-2 cursor-pointer z-50 relative"
              onClick={toggleMenu}
              aria-label="Menú"
              aria-expanded={isMenuOpen}
            >
              <span className="block">
                <span className="sr-only">Menú principal</span>
                <div className="flex flex-col justify-between" style={{ width: 'clamp(1.5rem, 2vw, 3rem)', height: 'clamp(1.25rem, 1.5vw, 2.5rem)' }}>
                  <span className={`block transition-all duration-300 ease-in-out ${isMenuOpen ? 'rotate-45 translate-y-2 bg-white' : 'bg-[#191a19]'}`} style={{ height: 'clamp(0.125rem, 0.15vw, 0.25rem)', width: '100%' }}></span>
                  <span className={`block transition-all duration-300 ease-in-out ${isMenuOpen ? 'opacity-0 bg-white' : 'bg-[#191a19]'}`} style={{ height: 'clamp(0.125rem, 0.15vw, 0.25rem)', width: '100%' }}></span>
                  <span className={`block transition-all duration-300 ease-in-out ${isMenuOpen ? '-rotate-45 -translate-y-2 bg-white' : 'bg-[#191a19]'}`} style={{ height: 'clamp(0.125rem, 0.15vw, 0.25rem)', width: '100%' }}></span>
                </div>
              </span>
            </button>

            {/* Logo - Center */}
            <div className="site-branding absolute left-1/2 transform -translate-x-1/2">
              <Link to="/" className="block">
                <img 
                  src="/images/logo2.png" 
                  alt="Navamuel - Mobiliario de Baño" 
                  style={{ height: 'clamp(2.5rem, 3vw, 5rem)', width: 'auto' }}
                />
              </Link>
            </div>

            {/* Empty space for balance */}
            <div style={{ width: 'clamp(3rem, 4vw, 6rem)' }}></div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <nav 
        className={`main-navigation lg:hidden fixed inset-0 bg-[#191a19] z-40 transition-all duration-500 ease-in-out ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        aria-hidden={!isMenuOpen}
      >
        <div className="h-full overflow-y-auto pt-20 pb-8 px-6">
          {/* Main Navigation */}
          <div className="space-y-2">
            {/* INICIO */}
            <div className={`transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '100ms' }}>
              <Link 
                to="/" 
                className="block text-white hover:text-gray-300 transition-colors duration-300 text-2xl font-light py-3 border-b border-white/20"
                onClick={toggleMenu}
              >
                INICIO
              </Link>
            </div>

            {/* AMBIENTES */}
            <div className={`transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '100ms' }}>
              <Link 
                to="/muebles-de-bano" 
                className="block text-white hover:text-gray-300 transition-colors duration-300 text-2xl font-light py-3 border-b border-white/20"
                onClick={toggleMenu}
              >
                AMBIENTES
              </Link>
            </div>

            {/* PROYECTOS */}
            <div className={`transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '100ms' }}>
              <Link 
                to="/proyectos" 
                className="block text-white hover:text-gray-300 transition-colors duration-300 text-2xl font-light py-3 border-b border-white/20"
                onClick={toggleMenu}
              >
                PROYECTOS
              </Link>
            </div>

            {/* PRODUCTOS */}
            {/* 
            <div className={`transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '200ms' }}>
              <button 
                className="w-full flex items-center justify-between text-white hover:text-gray-300 transition-colors duration-300 text-2xl font-light py-3 border-b border-white/20 cursor-pointer"
                onClick={() => toggleSubmenu('productos')}
              >
                <span>PRODUCTOS</span>
                <i className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${activeSubmenu === 'productos' ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
                activeSubmenu === 'productos' ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="pl-4 py-2 space-y-2 bg-gray-900/50">
                  <Link 
                    to="/productos" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Todos los productos
                  </Link>
                  <Link 
                    to="/productos?category=lavabos" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Lavabos
                  </Link>
                  <Link 
                    to="/productos?category=baneras" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Bañeras
                  </Link>
                  <Link 
                    to="/productos?category=espejos" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Espejos
                  </Link>
                  <Link 
                    to="/productos?category=encimeras" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Encimeras
                  </Link>
                  <Link 
                    to="/frentes" 
                    className="block text-white hover=text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Grifería
                  </Link>
                  <Link 
                    to="/productos?category=auxiliares" 
                    className="block text-white hover=text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Armarios auxiliares
                  </Link>
                  <Link 
                    to="/productos?category=vestidores" 
                    className="block text-white hover=text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Vestidores
                  </Link>
                  <Link 
                    to="/productos?category=accesorios" 
                    className="block text-white hover=text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Accesorios
                  </Link>
                </div>
              </div>
            </div>
            */}


            {/* MATERIALES */}
            <div className={`transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '400ms' }}>
              <button 
                className="w-full flex items-center justify-between text-white hover:text-gray-300 transition-colors duration-300 text-2xl font-light py-3 border-b border-white/20 cursor-pointer"
                onClick={() => toggleSubmenu('materiales')}
              >
                <span>MATERIALES</span>
                <i className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${activeSubmenu === 'materiales' ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
                activeSubmenu === 'materiales' ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="pl-4 py-2 space-y-2 bg-gray-900/50">
                  <Link 
                    to="/materiales" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Todos los materiales
                  </Link>
                  <Link 
                    to="/maderas" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Madera natural
                  </Link>
                  <Link 
                    to="/lacados" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Lacados
                  </Link>
                  <Link 
                    to="/piedra-natural" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Piedra natural
                  </Link>
                  <Link 
                    to="/piedra-compacta" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Piedra compacta
                  </Link>
                  <Link 
                    to="/porcelanicos" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Porcelánicos
                  </Link>
                  <Link 
                    to="/resinas-minerales" 
                    className="block text-white hover:text-gray-300 transition-colors duration-300 text-base font-light py-2"
                    onClick={toggleMenu}
                  >
                    Resinas minerales
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Secondary Links */}
          <div className={`mt-8 pt-8 border-t border-gray-800 space-y-2 transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '500ms' }}>
            <Link 
              to="/contacto" 
              className="block text-white hover:text-gray-300 transition-colors duration-300 text-lg font-light py-2"
              onClick={toggleMenu}
            >
              Contacto
            </Link>
            <Link 
              to="/descargas" 
              className="block text-white hover:text-gray-300 transition-colors duration-300 text-lg font-light py-2"
              onClick={toggleMenu}
            >
              Descargas
            </Link>
            <Link 
              to="/nosotros" 
              className="block text-white hover:text-gray-300 transition-colors duration-300 text-lg font-light py-2"
              onClick={toggleMenu}
            >
              Nosotros
            </Link>
          </div>

          {/* Social Links */}
          <div className={`mt-6 pt-6 border-t border-gray-800 transform transition-all duration-500 ease-out ${isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`} style={{ transitionDelay: '600ms' }}>
            <h3 className="text-white text-sm font-medium mb-4">Síguenos</h3>
            <div className="flex space-x-6">
              <Link to="https://www.instagram.com/navamuel.banos" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Desktop Menu - Fullscreen con distribución responsive */}
      <div
        className={`hidden lg:block fixed inset-0 bg-[#191a19] transition-all duration-700 z-40 ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="h-full w-full flex">
          {/* Main Navigation - Left Side - Usa porcentaje del viewport */}
          <div className="flex-1 flex items-start justify-center overflow-y-auto pt-20">
            <nav className="w-full px-[5vw] py-[5vh]">
              <ul className="space-y-[1vh]">
                {/* Inicio */}
                <li
                  className={`transition-all duration-700 border-b border-white/20 ${
                    isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '100ms' : '0ms' }}
                >
                  <Link
                    to="/"
                    onClick={closeMenu}
                    className="block text-white font-light py-[1.5vh] hover:pl-[2vw] transition-all duration-300 whitespace-nowrap cursor-pointer"
                    style={{ fontSize: 'clamp(2rem, 3.5vw, 6rem)' }}
                  >
                    INICIO
                  </Link>
                </li>

                {/* Ambientes */}
                <li
                  className={`transition-all duration-700 border-b border-white/20 ${
                    isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '100ms' : '0ms' }}
                >
                  <Link
                    to="/muebles-de-bano"
                    onClick={closeMenu}
                    className="block text-white font-light py-[1.5vh] hover:pl-[2vw] transition-all duration-300 whitespace-nowrap cursor-pointer"
                    style={{ fontSize: 'clamp(2rem, 3.5vw, 6rem)' }}
                  >
                    AMBIENTES
                  </Link>
                </li>

                {/* Proyectos */}
                <li
                  className={`transition-all duration-700 border-b border-white/20 ${
                    isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '100ms' : '0ms' }}
                >
                  <Link
                    to="/proyectos"
                    onClick={closeMenu}
                    className="block text-white font-light py-[1.5vh] hover:pl-[2vw] transition-all duration-300 whitespace-nowrap cursor-pointer"
                    style={{ fontSize: 'clamp(2rem, 3.5vw, 6rem)' }}
                  >
                    PROYECTOS
                  </Link>
                </li>

                {/* Productos */}
                {/*<li
                  className={`transition-all duration-700 border-b border-white/20 ${
                    isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '200ms' : '0ms' }}
                >
                  <div>
                    <button
                      type="button"
                      onClick={() => toggleSubmenu('productos')}
                      className="w-full text-left text-white font-light py-[1.5vh] hover:pl-[2vw] transition-all duration-300 flex items-center whitespace-nowrap group cursor-pointer"
                      style={{ fontSize: 'clamp(2rem, 3.5vw, 6rem)', gap: 'clamp(1rem, 1.5vw, 3rem)' }}
                    >
                      PRODUCTOS
                      <i
                        className={`ri-arrow-down-s-line transition-transform duration-500 ease-in-out ${
                          activeSubmenu === 'productos' ? 'rotate-180' : ''
                        }`}
                        style={{ fontSize: 'clamp(1.5rem, 2vw, 4rem)' }}
                      />
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-700 ease-in-out ${
                        activeSubmenu === 'productos' ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      <ul className="mt-[1vh] space-y-[0.5vh]" style={{ paddingLeft: 'clamp(2rem, 4vw, 6rem)' }}>
                        <li>
                          <Link
                            to="/productos"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Todos los productos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=lavabos"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Lavabos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=baneras"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Bañeras
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=espejos"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Espejos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=encimeras"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Encimeras
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/frentes"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Grifería
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=auxiliares"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Armarios auxiliares
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=vestidores"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Vestidores
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/productos?category=accesorios"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Accesorios
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>*/}



                {/* Materiales */}
                <li
                  className={`transition-all duration-700 border-b border-white/20 ${
                    isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                  }`}
                  style={{ transitionDelay: isMenuOpen ? '400ms' : '0ms' }}
                >
                  <div>
                    <button
                      type="button"
                      onClick={() => toggleSubmenu('materiales')}
                      className="w-full text-left text-white font-light py-[1.5vh] hover:pl-[2vw] transition-all duration-300 flex items-center whitespace-nowrap group cursor-pointer"
                      style={{ fontSize: 'clamp(2rem, 3.5vw, 6rem)', gap: 'clamp(1rem, 1.5vw, 3rem)' }}
                    >
                      MATERIALES
                      <i
                        className={`ri-arrow-down-s-line transition-transform duration-500 ease-in-out ${
                          activeSubmenu === 'materiales' ? 'rotate-180' : ''
                        }`}
                        style={{ fontSize: 'clamp(1.5rem, 2vw, 4rem)' }}
                      />
                    </button>
                    <div
                      className={`transition-all duration-700 ease-in-out ${
                        activeSubmenu === 'materiales'
                          ? 'max-h-[60vh] opacity-100 overflow-y-auto'
                          : 'max-h-0 opacity-0 overflow-hidden'
                      }`}
                      /* Cuando el submenú está abierto, permitimos scroll interno y limitamos
                         la altura al 60% del viewport para que elementos como "Piedra compacta"
                         no queden recortados en pantallas grandes. */
                    >
                      <ul className="mt-[1vh] space-y-[0.5vh]" style={{ paddingLeft: 'clamp(2rem, 4vw, 6rem)' }}>
                        <li>
                          <Link
                            to="/materiales"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Todos los materiales
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/maderas"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Maderas
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/lacados"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Lacados
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/piedra-natural"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Piedra natural
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/piedra-compacta"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Piedra compacta
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/porcelanicos"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Porcelánicos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/resinas-minerales"
                            onClick={closeMenu}
                            className="block text-white/80 font-light hover:text-white hover:pl-[1vw] transition-all duration-300 cursor-pointer"
                            style={{ fontSize: 'clamp(1rem, 1.5vw, 2.5rem)', paddingTop: 'clamp(0.5rem, 1vh, 1.5rem)', paddingBottom: 'clamp(0.5rem, 1vh, 1.5rem)' }}
                          >
                            Resinas minerales
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>

          {/* Right Panel - Info & Social - Ancho fijo en vw */}
          <div
            className={`bg-white/5 backdrop-blur-sm border-l border-white/10 flex flex-col justify-between overflow-y-auto transition-all duration-700 ${
              isMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
            style={{ 
              width: 'clamp(20rem, 25vw, 35rem)',
              padding: 'clamp(2rem, 3vw, 5rem)',
              transitionDelay: isMenuOpen ? '400ms' : '0ms'
            }}
          >
            {/* Top Section */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(1.5rem, 3vh, 4rem)' }}>
              {/* Info Links */}
              <div>
                <h3 className="text-white/50 uppercase tracking-wider" style={{ fontSize: 'clamp(0.75rem, 0.8vw, 1.2rem)', marginBottom: 'clamp(1rem, 2vh, 2rem)' }}>Info</h3>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(0.75rem, 1.5vh, 1.5rem)' }}>
                  <li>
                    <Link
                      to="/nosotros"
                      onClick={closeMenu}
                      className="text-white font-light hover:pl-[0.5vw] transition-all duration-300 block cursor-pointer"
                      style={{ fontSize: 'clamp(1rem, 1.2vw, 1.8rem)' }}
                    >
                      Nosotros
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contacto"
                      onClick={closeMenu}
                      className="text-white font-light hover:pl-[0.5vw] transition-all duration-300 block cursor-pointer"
                      style={{ fontSize: 'clamp(1rem, 1.2vw, 1.8rem)' }}
                    >
                      Contacto
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/descargas"
                      onClick={closeMenu}
                      className="text-white font-light hover:pl-[0.5vw] transition-all duration-300 block cursor-pointer"
                      style={{ fontSize: 'clamp(1rem, 1.2vw, 1.8rem)' }}
                    >
                      Descargas
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom Section - Social */}
            <div>
              <h3 className="text-white/50 uppercase tracking-wider" style={{ fontSize: 'clamp(0.75rem, 0.8vw, 1.2rem)', marginBottom: 'clamp(1rem, 2vh, 2rem)' }}>Síguenos</h3>
              <div className="flex" style={{ gap: 'clamp(1rem, 1.5vw, 2rem)' }}>
                <a
                  href="https://www.instagram.com/navamuel.banos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center border border-white/20 text-white hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
                  style={{ 
                    width: 'clamp(2.5rem, 3vw, 4rem)',
                    height: 'clamp(2.5rem, 3vw, 4rem)'
                  }}
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line" style={{ fontSize: 'clamp(1.25rem, 1.5vw, 2rem)' }} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
